import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import tobaccoDryRoomProductionsApi from '../../../api/tobaccoDryRoomProductionsApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'tobaccoDryProduction';

export const GetTobaccoDryProduction = createAsyncThunk(
  `${REDUCER_NAME}/getTobaccoDryRoomProduction`,
  async (params: any, thunkAPI) => {
    params.startDate = dayjs(params.startDate).format('YYYY-MM-DD');
    params.endDate = dayjs(params.endDate).format('YYYY-MM-DD');

    const res = await tobaccoDryRoomProductionsApi.get(params);

    if (res.status === 200) {
      return { ...res.data?.data, startDate: params.startDate, endDate: params.endDate };
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);
